import { useLocation } from 'react-router-dom';
import { ConfirmationTemplate } from '@templates';
import {
  resetIssueDetails,
  useSignsBollardsStore,
} from '../../../../hooks/useSignsBollardsStore';
import { REPORT_IT_WEBSITE_LINK, RETURN_TO_HOME_PAGE_TEXT } from '@constants';
import { RoutesList } from '../../../../routes/Routes';
import { basename } from '../../../../routes/basename';
import { usePreventConfirmationReturn } from '@hooks';

export const Confirmation = () => {
  const {
    data: {
      wantConfirmationEmail,
      contactUserOption,
      userDetails,
      confirmation,
    },
  } = useSignsBollardsStore();

  const location = useLocation();
  const YES_VALUE = 'yes';

  usePreventConfirmationReturn({
    confirmationUrl: basename + RoutesList.CONFIRMATION,
    redirectUrl: REPORT_IT_WEBSITE_LINK,
    onReset: resetIssueDetails,
    dependencies: [location.pathname],
  });

  let subText1;
  let subText2;

  const CONTACT_USER_BY_EMAIL =
    'We may contact you by phone or email, if we need more information.';

  const SENT_CONFIRMATION_EMAIL_TO_USER = `We've sent a confirmation email to ${userDetails.email}`;

  if (wantConfirmationEmail.toLowerCase() === YES_VALUE) {
    if (contactUserOption.toLowerCase() === YES_VALUE) {
      subText1 = <p>{SENT_CONFIRMATION_EMAIL_TO_USER}</p>;
      subText2 = <p>{CONTACT_USER_BY_EMAIL}</p>;
    } else {
      subText1 = <p>{SENT_CONFIRMATION_EMAIL_TO_USER}</p>;
      subText2 = <p>You won't be contacted further about the issue.</p>;
    }
  } else {
    if (contactUserOption.toLowerCase() === YES_VALUE) {
      subText2 = <p>{CONTACT_USER_BY_EMAIL}</p>;
    } else {
      subText2 = (
        <p>
          As you did not leave your contact details, you will not receive a
          confirmation email.
        </p>
      );
    }
  }

  const contentSubtext = (
    <div className="text-bodyLg text-text-body flex flex-col gap-6">
      <p>We've received your Signs and bollards report.</p>
      {subText1}
      {subText2}
      <p className="mb-4">
        Your report will be reviewed within{' '}
        {confirmation?.sla_text.toLowerCase()} by one of our team.
      </p>
    </div>
  );

  const navigationButton = {
    label: RETURN_TO_HOME_PAGE_TEXT,
    isExternalLink: true,
    href: REPORT_IT_WEBSITE_LINK,
  };

  return (
    <ConfirmationTemplate
      reference={confirmation?.case_reference}
      contentSubtext={contentSubtext}
      feedbackLink={true}
      button={navigationButton}
    />
  );
};
